import { IRootState } from '../../../store'
import { IPnMedicationOptionsState } from '../store/options.types'

export const getPnMedicationsOptionsSelector = (state: IRootState): IPnMedicationOptionsState =>
  state.options.pnMedicationOptions
